export default "__VITE_ASSET__BMNbyww0__"